/**
 * Browser-safe CSV parse (no Node polyfills).
 * Matches Papa.parse(file, { header: true, skipEmptyLines: true }) shape:
 * { data: object[], meta: { fields: string[] } }
 */

function parseCsvRows(text) {
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;

  const endRow = () => {
    row.push(field);
    field = "";
    const blank = row.every((cell) => String(cell).trim() === "");
    if (!blank) rows.push(row);
    row = [];
  };

  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += c;
      }
      continue;
    }
    if (c === '"') {
      inQuotes = true;
    } else if (c === ",") {
      row.push(field);
      field = "";
    } else if (c === "\r") {
      if (text[i + 1] === "\n") i++;
      endRow();
    } else if (c === "\n") {
      endRow();
    } else {
      field += c;
    }
  }
  endRow();
  return rows;
}

function rowsToObjects(rows) {
  if (!rows.length) {
    return { data: [], meta: { fields: [] } };
  }
  const headers = rows[0].map((h) => String(h ?? "").trim());
  const data = [];
  for (let r = 1; r < rows.length; r++) {
    const line = rows[r];
    const obj = {};
    for (let j = 0; j < headers.length; j++) {
      const key = headers[j];
      obj[key] = line[j] !== undefined ? line[j] : "";
    }
    data.push(obj);
  }
  return { data, meta: { fields: headers } };
}

/**
 * @param {File} file
 * @returns {Promise<{ data: Record<string, string>[], meta: { fields: string[] } }>}
 */
export function parseCsvFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = String(reader.result ?? "");
        const rows = parseCsvRows(text);
        resolve(rowsToObjects(rows));
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = () =>
      reject(reader.error || new Error("Failed to read file"));
    reader.readAsText(file, "UTF-8");
  });
}
